import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import Fluid from '../utils/Fluid'
import news from '../data/news.json'

const IndividualNewsScreen = ({ match }) => {
  const item = news.find((n) => String(n.id) === String(match.params.id))

  if (!item) {
    return (
      <section className='page-hero'>
        <div className='container-wide page-hero__inner'>
          <Link to='/news' className='article__back'>
            <i className='fa-solid fa-arrow-left' /> All news
          </Link>
          <h1 className='page-hero__title'>Story not found</h1>
        </div>
      </section>
    )
  }

  let image = null
  if (item.img) {
    try {
      image = require(`../resources/${item.img}`)
    } catch (e) {
      image = null
    }
  }

  const body = item.news.toString()

  return (
    <div>
      <section className='page-hero' style={{ paddingBottom: image ? 120 : 80 }}>
        <div className='aurora' aria-hidden='true'>
          <span className='aurora__blob aurora__blob--1' />
          <span className='aurora__blob aurora__blob--2' />
        </div>
        <Fluid />
        <div className='container-wide page-hero__inner'>
          <motion.div
            className='article'
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Link to='/news' className='article__back'>
              <i className='fa-solid fa-arrow-left' /> All news
            </Link>
            <div className='article__meta'>
              {item.type && (
                <span className='venue-pill venue-pill--glass'>{item.type}</span>
              )}
              {item.date && (
                <span style={{ color: 'rgba(255,255,255,.65)', fontSize: 14 }}>
                  {item.date}
                </span>
              )}
            </div>
            <h1
              className='page-hero__title'
              style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}
            >
              {item.title}
            </h1>
          </motion.div>
        </div>
      </section>

      <div className='container-wide page-body' style={{ paddingTop: image ? 0 : 64 }}>
        {image && (
          <motion.div
            className='article__image'
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            <img src={image} alt='' />
          </motion.div>
        )}
        <div className='article article__content'>
          {body.includes('<p>') ? (
            <div dangerouslySetInnerHTML={{ __html: body }} />
          ) : (
            <p>{body}</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default IndividualNewsScreen
